import { Flashcard, FlashcardStudyState, StudySessionProgressEnum } from "@knowt/syncing/graphql/schema";
import { flatten } from "lodash-es";
import { chunk } from "lodash-es";
import { FlashcardItem, MixedAd } from "./types";

export const mixAdsToFlashcards = ({
    flashcards,
    interval,
    max = 25,
}: {
    flashcards: Flashcard[];
    interval: number;
    max?: number;
}): (FlashcardItem | MixedAd)[] => {
    const chunkFlashcards = chunk(flashcards, interval) as (FlashcardItem | MixedAd)[][];

    for (let i = 0; i < max && i < chunkFlashcards.length; i++) {
        if (chunkFlashcards[i].length === interval) {
            chunkFlashcards[i].push({ type: "ad", index: i });
        }
    }

    return flatten(chunkFlashcards);
};

export const mergeProgressToFlashcards = ({
    flashcards,
    flashcardStudyStates,
}: {
    flashcards: Flashcard[];
    flashcardStudyStates?: Record<string, FlashcardStudyState>;
}): FlashcardItem[] => {
    return flashcards.map((flashcard, i) => ({
        ...flashcard,
        index: i,
        progress:
            flashcardStudyStates !== undefined
                ? (flashcardStudyStates?.[flashcard.flashcardId]?.progress ?? StudySessionProgressEnum.NEW)
                : undefined,
        sort: flashcardStudyStates?.[flashcard.flashcardId]?.sort ?? undefined,
    }));
};
